import 'jfilestyle';

jQuery(document).ready(function ($) {
    $(':file').jfilestyle({
        text: 'Upload',
        placeholder: 'Upload Resume* 16MB max. total',
        inputSize: 'auto',
    });
});